<template>
  <div>
    <!-- 空状态 -->
    <div v-if="!hasData" class="emp">
      <div class="es">[ 暂无数据 ]</div>
      <h3>等待报告生成</h3>
      <p>请先完成诊断并生成报告后查看。</p>
    </div>

    <!-- 建议内容 -->
    <div v-else>
      <!-- 针对性优化建议 -->
      <div class="diagnosis-panel">
        <div class="panel-header">
          <span class="pdot cyan"></span>针对性优化建议
          <span class="pid">按严重程度排序</span>
        </div>
        <div class="panel-body">
          <div class="rg">
            <div
              v-for="(rec, idx) in recommendations"
              :key="idx"
              class="rec"
              :class="rec.priority[0]"
            >
              <div class="rt" :style="{ color: priorityColor(rec.priority) }">
                {{ priorityLabel(rec.priority) }} ｜ {{ rec.dimensionName }} {{ rec.score != null ? rec.score + '分' : '' }}
              </div>
              <h4>{{ rec.title }}</h4>
              <p>{{ rec.desc }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 分期执行策略 -->
      <div class="diagnosis-panel">
        <div class="panel-header">
          <span class="pdot cyan"></span>分期执行策略
          <span class="pid">时间线</span>
        </div>
        <div class="panel-body">
          <div class="g2">
            <!-- 第一阶段：止血 -->
            <div>
              <h4 style="margin-bottom:8px;font-family:var(--mono);font-size:0.81rem;">第一阶段（1-3月）— 止血</h4>
              <div style="font-size:0.81rem;color:var(--text2);">
                <template v-if="phaseStrategies.phase1.length">
                  <div v-for="(p, i) in phaseStrategies.phase1" :key="i">
                    · {{ p.score != null ? '修复「' + p.name + '」(' + p.score + '分)：' : '' }}{{ p.action }}
                  </div>
                </template>
                <div v-else>· 各项指标均在安全线以上，无需紧急干预</div>
              </div>
            </div>

            <!-- 第二阶段：调结构 -->
            <div>
              <h4 style="margin-bottom:8px;font-family:var(--mono);font-size:0.81rem;">第二阶段（3-6月）— 调结构</h4>
              <div style="font-size:0.81rem;color:var(--text2);">
                <template v-if="phaseStrategies.phase2.length">
                  <div v-for="(p, i) in phaseStrategies.phase2" :key="i">
                    · {{ p.score != null ? '改善「' + p.name + '」(' + p.score + '分)：' : '' }}{{ p.action }}
                  </div>
                </template>
                <div v-else>· 推进渠道结构精细化，将各维度提升至85分以上</div>
              </div>
            </div>
          </div>

          <!-- 第三阶段：建体系 -->
          <div style="margin-top:12px;">
            <h4 style="margin-bottom:6px;font-family:var(--mono);font-size:0.81rem;">第三阶段（6-12月）— 建体系</h4>
            <div style="font-size:0.81rem;color:var(--text2);">
              · 建立渠道结构健康度常态化监控机制<br>
              · 推动DTC占比持续提升<br>
              · 布局新兴渠道业态<br>
              · 完善渠道结构复盘与迭代流程
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getPriorityLabel, getPriorityColor } from '../../utils/constants'

export default {
  name: 'RecTab',
  computed: {
    ...mapState('diagnosis', ['scores']),
    ...mapGetters('diagnosis', ['recommendations', 'phaseStrategies', 'totalScore']),
    hasData() {
      return this.totalScore != null
    }
  },
  methods: {
    priorityLabel: getPriorityLabel,
    priorityColor: getPriorityColor
  }
}
</script>
